var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-dialog', {
    model: {
      value: _vm.MARKETPLACE_CATEGORIES.show,
      callback: function callback($$v) {
        _vm.$set(_vm.MARKETPLACE_CATEGORIES, "show", $$v);
      },
      expression: "MARKETPLACE_CATEGORIES.show"
    }
  }, [_c('dialog-list-layout', _vm._l(_vm.getPreparedCategories, function (category) {
    return _c('option-panel', {
      key: category.id,
      attrs: {
        "option": category
      },
      on: {
        "click": function click($event) {
          return _vm.handleClick(category);
        }
      }
    });
  }), 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }